import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const LinksToOtherWebsites = () => {
  return (
    <>
      <Subtitle>Links to Other Websites</Subtitle>
      <Paragraph>
        The Site may provide links to other websites which are not owned or
        controlled by Glints or its affiliates. Personal information and data
        from you may be collected on these other websites when you visit such
        websites and make use of the services provided therein. Where and when
        you decide to click on any advertisement or hyperlink on the Site which
        grants you access to another website, the protection of your personal
        information and data which are deemed to be private and confidential may
        be exposed in these other websites.
      </Paragraph>
      <Paragraph>
        If you register on the Site via your accounts from social networking
        sites (including but not limited to Facebook, Google and LinkedIn), you
        are deemed to have consented to the terms of this Privacy Statement, and
        such your personal data provided to those networking tools may be
        obtained by Glints and be used by Glints and its authorized persons in
        and outside of the your country for the purpose of providing services
        and marketing materials to the you. Where this occurs, you will be
        provided clear notice by these social networking sites. Glints and its
        authorized personnel may gain access and use your personal data obtained
        in such a way, subject to the other provisions of this Privacy
        Statement.
      </Paragraph>
      <Paragraph>
        This Privacy Statement is only applicable to the Site. You are reminded
        that this Privacy Statement grants no protection to your personal
        information and data that may be exposed on websites other than the
        Site, and Glints is not responsible for the privacy practices of such
        other websites. You are strongly recommended to refer to the privacy
        policies of such other websites before using those websites.
      </Paragraph>
    </>
  );
};
